// extracted by mini-css-extract-plugin
export var messageSideLeft = "_io-1";
export var stateContainer = "_io-0";